import { render } from "./Newsletter.vue?vue&type=template&id=7c23922a&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"

import "./Newsletter.vue?vue&type=style&index=0&id=7c23922a&lang=css&scoped=true"

import exportComponent from "/Users/mad/Business/156kr/Clients/ archive/kultursommer/kultursommer_web25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c23922a"]])

export default __exports__